// export const apiUrl = 'http://127.0.0.1:8000/apis/';
// export const assetsUrl = 'http://127.0.0.1:8000/apibackend';
// export const domainname = 'https://upskillscert.com';

export const apiUrl = 'https://upskillscert.com/apibackend/apis/';
export const assetsUrl = 'https://upskillscert.com/apibackend';
export const domainname = 'https://upskillscert.com';